import { Section, Kicker, Reveal } from "./primitives";
import { CtaButton } from "./Cta";

const ROWS = [
  { item: "Programa completo Absorbancia Perfecta (5 módulos en vivo + acceso de por vida)", amt: "$500 USD" },
  { item: "Plantillas de calibración + esquemas de diagnóstico en celular", amt: "$120 USD" },
  { item: "Bono 1 · Pack de informes técnicos institucionales", amt: "$150 USD" },
  { item: "Bono 2 · Masterclass control de calidad y configuración", amt: "$200 USD" },
  { item: "Bono 3 · Canal privado de alumnos y soporte técnico", amt: "$300 USD" },
];

export const Inversion = () => (
  <Section id="inversion" band>
    <Reveal>
      <Kicker num="06" label="Valor real vs. oferta especial" />
      <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        La inversión de hoy, comparada con lo que realmente vale
      </h2>
    </Reveal>

    <Reveal delay={0.1}>
      <div className="mt-12 rounded-2xl border border-white/10 bg-[#0B1322]/70 px-6 py-3 sm:px-8">
        {ROWS.map((r) => (
          <div key={r.item} className="flex items-baseline justify-between gap-6 border-b border-dashed border-white/10 py-4">
            <span className="text-sm text-slate-300 sm:text-base">{r.item}</span>
            <span className="shrink-0 font-tech text-sm font-semibold text-slate-100 sm:text-base">{r.amt}</span>
          </div>
        ))}
        <div className="flex items-baseline justify-between gap-6 py-5">
          <span className="font-display text-base font-bold text-slate-50 sm:text-lg">Valor total acumulado</span>
          <span className="font-tech text-xl font-bold text-amber-400 sm:text-2xl">+$1,270 USD</span>
        </div>
      </div>
    </Reveal>

    <Reveal delay={0.15}>
      <div className="mt-8 rounded-3xl bg-gradient-to-r from-amber-400/60 via-cyan-400/40 to-amber-400/60 p-px">
        <div className="flex flex-col items-center justify-between gap-8 rounded-3xl bg-[#0B1322] p-8 sm:p-10 lg:flex-row">
          <div data-testid="price-box">
            <span className="font-tech text-[11px] tracking-[0.3em] text-amber-400">
              OFERTA EXCLUSIVA DE LANZAMIENTO — HOY
            </span>
            <div className="mt-3 text-sm text-slate-500">
              Precio de venta regular: <span className="line-through">$500 USD</span>
            </div>
            <div className="mt-1 font-display text-5xl font-extrabold tracking-tight text-slate-50 sm:text-6xl">
              $297 <span className="text-2xl text-slate-400">USD</span>
            </div>
            <div className="mt-3 max-w-sm text-sm text-slate-400">
              O difiérelo en cuotas locales según las opciones de tu país en Hotmart.
            </div>
          </div>
          <CtaButton testId="price-cta-button" className="w-full lg:w-auto">
            Asegurar mi cupo en Absorbancia Perfecta por $297
          </CtaButton>
        </div>
      </div>
    </Reveal>

    <Reveal delay={0.2}>
      <p className="mx-auto mt-10 max-w-3xl text-center text-sm leading-relaxed text-slate-400 sm:text-base">
        La matemática es simple: con tan solo <b className="text-slate-100">3 mantenimientos preventivos</b> o
        una sola restauración de absorbancia que ejecutes aplicando este método, habrás
        recuperado el 100% de tu inversión — y todo el conocimiento te quedará como
        ganancia pura para el resto de tu carrera.
      </p>
    </Reveal>
  </Section>
);
